<template>
    <v-container fluid class="mt-4 footer-container pa-0">
        <v-row no-gutters justify="center" id="logos-footer" class="white lighten-5">
            <div class="logos-footer">
                <img class="imagen-logos" :src="enlaceLogos" />
            </div>
        </v-row>
        <v-row no-gutters justify="center" class="mt-10 mb-10">
            <v-container class="footer-enlaces d-flex">
                <v-row no-gutters>
                    <v-col cols="12" md="4" align-self="center" class="logos-footer">
                        <img class="logo-vinaros" :src="enlaceLogoVinaros" />
                    </v-col>
                    <v-col cols="6" md="4" align-self="center">
                        <ul class="enlaces-footer">
                            <li>
                                <a :href="enlaceAvisoLegal.url" target="_blank">
                                    {{ enlaceAvisoLegal.texto }}
                                </a>
                            </li>
                            <li>
                                <a :href="enlacePoliticaPrivacidad.url" target="_blank">
                                    {{ enlacePoliticaPrivacidad.texto }}
                                </a>
                            </li>
                        </ul>
                    </v-col>

                    <v-col cols="6" md="4" align-self="center">
                        <v-list dense color="transparent" dark class="contacto">
                            <v-subheader class="titulo-contacto">
                                <span> {{ tituloContacto }}</span>
                            </v-subheader>

                            <v-list-item
                                v-for="contacto in enlacesContacto"
                                :key="contacto.texto"
                            >
                                <v-list-item-icon class="ma-0 mr-3">
                                    <v-icon small> {{ contacto.icono }} </v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        <a
                                            class="enlaces-contacto"
                                            :href="contacto.enlace"
                                        >
                                            {{ contacto.texto }}
                                        </a>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-col>
                </v-row>
            </v-container>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: "FooterDesktop",
    props: {
        esMovil: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data: function () {
        return {
            enlaceLogos:
                "https://vinaros2030.com/wp-content/uploads/2022/09/logos-agenda-urbana-2.png",
            enlaceLogoVinaros:
                "https://vinaros2030.com/wp-content/uploads/2022/06/logoVinarozBlanco_0.png",

            enlaceAvisoLegal: {
                texto: this.$t("layout.footer.aviso-legal"),
                url: "https://www.vinaros.es/index.php/es/contenido/aviso-legal",
            },

            enlacePoliticaPrivacidad: {
                texto: this.$t("layout.footer.politica-privacidad"),
                url:
                    "https://www.vinaros.es/index.php/es/contenido/politica-de-privacidad",
            },

            tituloContacto: this.$t("layout.footer.titulo-contacto"),
            enlacesContacto: [
                {
                    icono: "fa-phone",
                    texto: "964 407 700",
                    enlace: "tel:964407700",
                },
                {
                    icono: "fa-envelope",
                    texto: "info@vinaros.es",
                    enlace: "mailto:info@vinaros.es",
                },
                {
                    icono: "fa-location-dot",
                    texto: "Pl. Parroquial, 12 12500 Vinaròs",
                    enlace: "https://goo.gl/maps/9uU5Ndg7XqVsTpAw9",
                },
            ],
        };
    },
};
</script>

<style scoped>
#logos-footer {
    max-width: 100% !important;
}
.footer-container {
    max-width: 100% !important;
    padding-bottom: 20px;
    font-size: 0.875em;
    background-color: #193f75;
}

.enlaces-footer {
    list-style: none;
}
.enlaces-footer li a {
    color: #f9f9f9;
    text-decoration: underline;
}

.v-list--dense .v-list-item .v-list-item__title {
    font-weight: 400;
}
.v-subheader.titulo-contacto {
    margin: 0 0 10px;
    font-size: 1em;
    line-height: 1.2;
    font-weight: bold;
    color: #f9f9f9;
}

.contacto .v-list-item {
    min-height: 0;
}

.enlaces-contacto {
    color: #f9f9f9;
}

.logos-footer {
    text-align: center;
    position: relative;
    width: 100%;
}

.imagen-logos {
    width: 90%;
    max-width: 1185px;
}

.logo-vinaros {
    height: 69px;
    width: 200px;
}

.footer-enlaces {
    max-width: 1200px !important;
    position: relative !important;
}
</style>
